import React, { useState, useEffect } from "react";
import ContentWrapper  from "../ContentWrapper/ContentWrapper";
import SideBar from "../../Components/Sidebar/Sidebar";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../store";
import CustomBreadcrumb from "../../Components/CustomBreadcrumb/CustomBreadcrumb";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Nav/Navbar";
import { setAuthenticated, setToken } from "../../Reducer/AuthReducer";
import { useNavigate } from "react-router-dom";
import "../Layout.css";
import {
  RiMenuFoldLine,
  RiMenuUnfoldLine,
} from "react-icons/ri";

type DashboardLayoutProps = {
  clientConfig: any; // Define the type of clientConfig as needed
  children: React.ReactNode
};

export const DashboardLayout = ({ children,clientConfig }:DashboardLayoutProps ) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
  const isLogin = useSelector((state: RootState) => state.auth.isAuthenticated);
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    if (token && isAuthenticated) {
      dispatch(setToken(token));
      dispatch(setAuthenticated(true));
    }

  }, [isLogin, token, isAuthenticated, dispatch, navigate]);

  if (!isLogin) {
  navigate("/login");
  }
  const handleOnCollapse = (collapsed: boolean) => {
    setCollapsed(collapsed);
  };

  return (
    <div
      className={`app-layout ${
        collapsed
          ? "app-layout--sidebar-collapsed"
          : "app-layout--sidebar-expanded"
      }`}
    >
      <SideBar collapse={collapsed} />

      <button
        type="button"
        className="app-layout__sidebar-toggle"
        onClick={() => handleOnCollapse(!collapsed)}
        aria-label={
          collapsed ? "Expand sidebar" : "Collapse sidebar"
        }
      >
        {collapsed ? (
          <RiMenuUnfoldLine />
        ) : (
          <RiMenuFoldLine />
        )}
      </button>

      <div className="app-layout__body">
        <Header
          collapsed={collapsed}
          clientLogo={clientConfig.logo_format_2}
        />

        <main className="app-layout__main">
          <CustomBreadcrumb />
          <ContentWrapper>{children}</ContentWrapper>
          <Footer />
        </main>
      </div>
    </div>
  );
}